import { NgModule } from '@angular/core';
import { RouterModule, Router, RouteConfigLoadStart, RouteConfigLoadEnd, NavigationEnd } from '@angular/router';
import { routes } from '@src/app/app.routes';
import { NgxSpinnerService } from 'ngx-spinner';

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { 
  constructor(
    private router: Router,
    private _SpinnerService:NgxSpinnerService
) {
    router.events.subscribe((event) => {

        if (event instanceof RouteConfigLoadStart) {
         
            //abp.ui.setBusy();
            this._SpinnerService.show();
        }

        if (event instanceof RouteConfigLoadEnd) {
          this._SpinnerService.hide();
        }

        if (event instanceof NavigationEnd) {
            //document.querySelector('meta[property=og\\:url').setAttribute('content', window.location.href);
            this._SpinnerService.hide();
          }
    });
}
}

